import React, { PureComponent } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userStyles } from "../styles";
import {
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import MyPATStepper from "../../common/MyPATStepper";
import MyPATStep, {
  MyPATStepSubHeading,
  MyPATStepTitle,
} from "../../common/MyPATStep";
import MyPATExpansionStep from "../../common/MyPATExpansionStep";
import MyPATExpansionStepSubCard from "../../common/MyPATExpansionStepSubCard";
import ProgressBar from "../containers/CardData/CardDataTabs/ProgressBar";
import { StepStatus } from "../../common/types/Stepper";
import MyPATTab from "../../common/MyPATTab";
import MyPATTabs from "../../common/MyPATTabs";
import DialogLarge from "../common/DialogLarge";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  TableHead,
  Link,
  TextField,
  Tooltip,
} from "@material-ui/core";
import {
  MyPATDialog,
  MyPATSelect,
  MyPATTextArea,
  MyPATTextField,
} from "../../common";
import PerfectScrollbar from "react-perfect-scrollbar";
import YourTaskListing from "./YourTaskListing";
import OrderNotes from "./OrderNotes";
import { withRouter } from "react-router-dom";
import CreateOwnerDealine from "./CreateOwnerDeadline";
import {
  isLoggedInUserCenterHead,
  isLoggedInUserMultiCenterHead,
  getLoggedInUserRole,
  generateDefaultContentRequest,
  convertRequestPriorityToDislayValue,
  getAssignorName,
  getAllRequestOwnerNames,
  getRequestCreatorName,
} from "../helpers/createContentRequest";
import contentRequestServices from "../services/contentRequestServices";
import { getContentRequest } from "../actions/contentRequestActions";
import { ContentRequest, Owners, Question, TopNav } from "../types/ContentRequest";
import dateService from "../../common/services/dateService";
import { RoleTypes, Priority, PriorityTitle } from "../types/Constants";
import YourTask from "../containers/CardData/CardDataTabs/YourTask";
import _, { indexOf } from "lodash";
import { RequestContentType } from "../types/ContentRequestCreate";
import ACLService from "../../acl/services/aclService";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import moment from "moment";
import { checkIfRequestForMyOrg } from "../helpers/createContentRequest";
import InputViaDialog from "../common/InputViaDialog";
import MyPATTruncateText from "../../common/MyPATTruncateText";
import RequestHistoryDrawer from "./RequestHistoryDrawer";
import classNames from "classnames";
import { extractContent } from "../../../utils";

interface Props extends WithStyles<typeof userStyles> {
  match: any;
  getContentRequest: Function;
  contentRequest: ContentRequest;
  isSaveHidden: boolean;
  onEdit: () => void;
  questions: Question[];
  activeTab: any;
  authUser: any;
}

interface State {
  statusCreated: string;
  statusEvaluted: string;
  statusPending: string;
  requestId: any;
  requestData: ContentRequest;
  isLoggedInMultiCenterHead: boolean;
  isUserCenterHead: boolean;
  isUserMultiCenterHead: boolean;
  isUserContentAuthor: boolean;
  isRequestCreatedByMe: boolean;
  activeSubjectTab: any;
  rows: Question[];
  showContentHistory: boolean;
}

class AfterAssingment extends PureComponent<Props, State> {
  requestContentType: RequestContentType;
  isMultiCenterHead: boolean;
  isCenterHead: boolean;
  requestIdFromParams: string;
  constructor(props: any) {
    super(props);
    this.requestContentType = props.match.params.requestContentType;
    this.requestIdFromParams = props.match.params.requestId;
    this.isMultiCenterHead = isLoggedInUserMultiCenterHead();
    this.isCenterHead = isLoggedInUserCenterHead();
    const rows = !_.isEmpty(props.questions) ? props.questions : [EMPTY_ROW];

    this.state = {
      rows,
      statusCreated: StepStatus.DONE,
      statusEvaluted: StepStatus.INPROGRESS,
      statusPending: StepStatus.PENDING,
      requestId: "",
      isLoggedInMultiCenterHead: false,
      requestData: generateDefaultContentRequest(this.requestContentType),
      isUserCenterHead: false,
      isUserMultiCenterHead: false,
      isUserContentAuthor: false,
      isRequestCreatedByMe: false,
      activeSubjectTab: "",
      showContentHistory: false
    };
  }

  toggleShowContentHistory = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showContentHistory: !prevState.showContentHistory
      }
    })
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const requestId = params.requestId;

    // Get CR object here, call based on MCH, CH or author
    const isUserCenterHead = isLoggedInUserCenterHead();
    const isUserMultiCenterHead = isLoggedInUserMultiCenterHead();
    const isUserContentAuthor = !isUserCenterHead && !isUserMultiCenterHead;
    const loggedInUserRole = getLoggedInUserRole();

    this.setState({
      requestId: requestId,
      isUserCenterHead: isUserCenterHead,
      isUserMultiCenterHead: isUserMultiCenterHead,
      isUserContentAuthor: isUserContentAuthor,
    });

    this.props.getContentRequest({
      requestId: this.requestIdFromParams,
      isUserCenterhead: isUserCenterHead,
      isUserMultiCenterHead: isUserMultiCenterHead,
      isUserContentAuthor: isUserContentAuthor,
    });

    this.setState({
      isLoggedInMultiCenterHead: isUserMultiCenterHead,
      requestId: this.requestIdFromParams,
    });
    this.fetchRequestData();
  }

  componentDidUpdate(nextProps: Props) {
    if (nextProps.contentRequest !== this.props.contentRequest) {
    }
  }
  fetchRequestData = async () => {
    try {
      const response = await contentRequestServices.getRequestProgress(
        this.requestIdFromParams,
        this.isMultiCenterHead
      );
      const firstSubjectName = _.get(
        response.contentRequestDetails,
        "requestInfo.details.subjects[0].name",
        ""
      );
      this.setState({
        requestData: response.contentRequestDetails,
        activeSubjectTab: firstSubjectName,
      });
    } catch (error) {
      console.log(error);
    }
  };

  getRequestOwnerNames(owners: any) {
    let requestOwnerNames = "";
    if (owners.length === 0) {
      return "";
    }
    if (owners.length > 0) {
      for (let i = 0; i < owners.length; i++) {
        if (owners[i].client) {
          requestOwnerNames += owners[i].client.name + ",";
        }
      }
    }

    let names = requestOwnerNames.split(",");
    let updatedNames = "";
    if (names.length > 2) {
      for (let i = 0; i < 2; i++) {
        updatedNames += names[i] + ",";
      }
      updatedNames += `+${names.length - 2}`;
    } else {
      names.forEach((name: string) => {
        updatedNames += name;
      });
    }
    return updatedNames;
  }

  getContentCreatedStatus() {
    console.log('In getContentCreatedStatus')
    if (this.props.contentRequest) {
      if (
        !this.getRequestOwnerNames(this.props.contentRequest.requestInfo.owners)
      ) {
        return "N/A";
      }

      if(this.isMultiCenterHead){
        // console.log('MCH', _.get(this.props.contentRequest, 'requestInfo.owners', []))

        return this.checkTestCreatedStatus(
          _.get(this.props.contentRequest, 'requestInfo.owners', [])
        )
      }

      const totalCompleted = _.get(this.props.contentRequest, 'progress.details.test.totalCompleted', 0)
      const totalCount = _.get(this.props.contentRequest, 'progress.details.test.totalCount', 0);

      if (totalCompleted > 0 && totalCompleted === totalCount) {
        return StepStatus.DONE;
      } else if (totalCompleted > 0) {
        return StepStatus.INPROGRESS;
      } else {
        return StepStatus.PENDING;
      }


      // if (this.props.contentRequest.completionPercent === 0) {
      //   return StepStatus.PENDING;
      // }

      // if (
      //   this.props.contentRequest.completionPercent > 0 &&
      //   this.props.contentRequest.completionPercent < 100
      // ) {
      //   return StepStatus.INPROGRESS;
      // }

      // if (this.props.contentRequest.completionPercent === 100) {
      //   return StepStatus.DONE;
      // }
    } else {
      return StepStatus.PENDING;
    }
  }

  checkProgressStatusInProgress = (roles: any) => {
    const rolesData = roles.roles;
    console.log({roles, rolesData});
    // let isInProgress = false;
    let overAllCompleted = 0;
    let overAllCount = 0;
    if (rolesData) {
      Object.keys(rolesData).forEach((role: any) => {
        overAllCompleted += rolesData[role].totalCompleted;
        overAllCount += rolesData[role].totalCount
      });
    }
    
    return overAllCompleted > 0 && overAllCompleted < overAllCount;
  };

  checkProgressStatusPending = (roles: any) => {
    const rolesData = roles.roles;
    // console.log({roles, rolesData})
    let isPending = true;
    if (rolesData) {
      Object.keys(rolesData).forEach((role: any) => {
        if (rolesData[role].totalCompleted > 0) {
          isPending = false;
        }
      });
    }
    return isPending;
  };

  checkProgressStatusDone = (roles: any) => {
    const rolesData = roles.roles;
    let isDone = true;
    if (rolesData) {
      Object.keys(rolesData).forEach((role: any) => {
        if (rolesData[role].totalCompleted !== rolesData[role].totalCount) {
          isDone = false;
        }
      });
    }
    return isDone;
  };

  checkContentCreatedQuestionStatus = (owners: any[]) => {
    let overAllTotalCompleted = 0;
    let overAllTotalCount = 0;
    owners.forEach((owner:any) => {
      if(owner.type === 'subject') {
        const { subjects } = owner;
        
        subjects && subjects.forEach((subject:any) => {
          const { progress } = subject;
          if(progress) {
            const { totalCompleted = 0, totalCount = 0 } = progress;
            // console.log('From Progress', totalCompleted, totalCount)
            overAllTotalCompleted += totalCompleted;
            overAllTotalCount += totalCount;
          }
        })
      }
    })

    // console.log('::::::::::Total Completed:::::::::::',overAllTotalCompleted)
    // console.log('::::::::::Total Count::::::::::',overAllTotalCount)

    if(overAllTotalCompleted === 0) return StepStatus.PENDING
    if(overAllTotalCompleted > 0 && overAllTotalCompleted < overAllTotalCount) return StepStatus.INPROGRESS
    if(overAllTotalCompleted === overAllTotalCount) return StepStatus.DONE
  }

  checkTestCreatedStatus = (owners: any[]) => {
    let overAllTotalCompleted = 0;
    let overAllTotalCount = 0;
    owners.forEach((owner:any) => {
      if(owner.type === 'test-compiler') {
        
        
        
          const { progress } = owner;
          if(progress) {
            const { totalCompleted = 0, totalCount = 0 } = progress;
            // console.log('From Test Progress', totalCompleted, totalCount)
            overAllTotalCompleted += totalCompleted;
            overAllTotalCount += totalCount;
          }
        
      }
    })

    // console.log('::::::::::Total Test Completed:::::::::::',overAllTotalCompleted)
    // console.log('::::::::::Total Test Count::::::::::',overAllTotalCount)

    if(overAllTotalCompleted === 0) return StepStatus.PENDING
    if(overAllTotalCompleted > 0 && overAllTotalCompleted < overAllTotalCount) return StepStatus.INPROGRESS
    if(overAllTotalCompleted === overAllTotalCount) return StepStatus.DONE
  }

  getContentCreatedQuestionsStatus() {

    if(this.isMultiCenterHead) {
      // console.log('Is Multi Center Head')
      // console.log(_.get(this.props.contentRequest, 'requestInfo.owners', []))
      
      return this.checkContentCreatedQuestionStatus(
        _.get(this.props.contentRequest, 'requestInfo.owners', [])
      )
    }

    if (this.props.contentRequest) {
      if (
        this.checkProgressStatusPending(
          _.get(this.props.contentRequest.progress, "details.question", {})
        )
      ) {
        return StepStatus.PENDING;
      }
      if (
        this.checkProgressStatusInProgress(
          _.get(this.props.contentRequest.progress, "details.question", {})
        )
      ) {
        return StepStatus.INPROGRESS;
      }
      if (
        this.checkProgressStatusDone(
          _.get(this.props.contentRequest.progress, "details.question", {})
        )
      ) {
        return StepStatus.DONE;
      }

      // if(!(this.getRequestOwnerNames(this.props.contentRequest.requestInfo.owners))){
      //   return 'N/A'
      //  }
    } else {
      return StepStatus.PENDING;
    }
  }

  checkTestProgress = (owners: any) => {

    owners.forEach((owner: any) => {
      if(owner.type === 'test-compiler') {
        owner &&
          owner.subjects &&
          owner.subjects.forEach((subject: any) => {
            const { progress } = subject;
            const { totalCompleted, totalCount} = progress;
            // console.log('checkTestProgress', totalCompleted, totalCount)
            if(totalCompleted === 0) return StepStatus.PENDING;
            if(totalCompleted > 0 && totalCompleted < totalCount) return StepStatus.INPROGRESS;
            if(totalCompleted === totalCount) return StepStatus.DONE;
         
          });
      }
    });

  }

  checkTestProgressCenterHead = () => {

  }

  checkTestProgressStatusPending = (owners: any) => {
    let isStatusPending = true;
    owners.forEach((owner: any) => {
      if(owner.type === 'test-compiler') {
        owner &&
          owner.subjects &&
          owner.subjects.forEach((subject: any) => {
            if (subject.progress && subject.progress.totalCompleted > 0) {
              isStatusPending = false;
            }
          });
      }
    });
    return isStatusPending;
  };

  checkTestProgressStatusInProgress = (owners: any) => {
    let isStatusInProgress = false;
    owners.forEach((owner: any) => {
      if(owner.type === 'test-compiler') {
        owner &&
          owner.subjects &&
          owner.subjects.forEach((subject: any) => {
            if (
              subject.progress &&
              subject.progress.totalCompleted > 0 &&
              subject.progress.totalCompleted < subject.progress.totalCount
            ) {
              isStatusInProgress = true;
            }
          });
      }
    });
    return isStatusInProgress;
  };

  checkTestProgressStatusDone = (owners: any) => {
    let isStatusDone = true;
    owners.forEach((owner: any) => {
      if(owner.type === 'test-compiler') {
        owner &&
          owner.subjects &&
          owner.subjects.forEach((subject: any) => {
            if (subject.progress.totalCompleted !== subject.progress.totalCount) {
              isStatusDone = false;
            }
          });
      }
    });

    return isStatusDone;
  };

  getContentCreatedTestStatus() {
    // console.log('Test Progress',_.get(this.props.contentRequest.progress, "details.test", {}))
    if(this.isMultiCenterHead){
      return this.checkTestCreatedStatus(
        _.get(this.props.contentRequest, 'requestInfo.owners', [])
      )
 
    }
    if (this.props.contentRequest) {
      // console.log('In IF')
      if (
        this.checkProgressStatusPending(
          _.get(this.props.contentRequest.progress, "details.test", {})
        )
      ) {
        // console.log('In Pending')
        return StepStatus.PENDING;
      }

      if (
        this.checkProgressStatusInProgress(
          _.get(this.props.contentRequest.progress, "details.test", {})
        )
      ) {
        // console.log('In In Progress')
        return StepStatus.INPROGRESS;
      }

      if (
        this.checkProgressStatusDone(
          _.get(this.props.contentRequest.progress, "details.test", {})
        )
      ) {
        // console.log('In Done')
        return StepStatus.DONE;
      }
      // return this.checkTestProgress(
      //   _.get(this.props.contentRequest, "requestInfo.owners", [])
      // )
    } else {
      return StepStatus.PENDING;
    }
  }

  getStatus(percent: any) {
    if (percent === 0 || percent === undefined) {
      return StepStatus.PENDING;
    }

    if (percent > 0 && percent < 100) {
      return StepStatus.INPROGRESS;
    }

    if (percent === 100) {
      return StepStatus.DONE;
    } else {
      return StepStatus.INPROGRESS;
    }
  }

  getSubStepStatusContent(role: RoleTypes) {
    let overallCompleted;
    let overallCount;
    overallCompleted = _.get(this.props.contentRequest, 'progress.details.question.totalCompleted', 0);
    overallCount = _.get(this.props.contentRequest, 'progress.details.question.totalCount', 0);
    const overallPercent = (overallCompleted / overallCount) * 100;
    switch (role) {
      case RoleTypes.creator:
        let totalCompletedCreator;
        let totalCountCreator;
        totalCompletedCreator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.creator
              .totalCompleted) ||
          0;
        totalCountCreator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.creator
              .totalCount) ||
          0;
        let percentCompleteCreator =
          (totalCompletedCreator / totalCountCreator) * 100;
        console.log('Percent Creator', percentCompleteCreator);
        if (percentCompleteCreator) {
          console.log(this.getStatus(percentCompleteCreator))
          return this.getStatus(percentCompleteCreator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.evaluator:
        let totalCompletedEvaluator;
        let totalCountEvaluator;
        totalCompletedEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.evaluator
              .totalCompleted) ||
          0;
        totalCountEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.evaluator
              .totalCount) ||
          0;
        let percentCompleteEvaluator =
          (totalCompletedEvaluator / totalCountEvaluator) * 100;
        if (percentCompleteEvaluator) {
          return this.getStatus(percentCompleteEvaluator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.langEvaluator:
        let totalCompletedLangEvaluator;
        let totalCountLangEvaluator;
        totalCompletedLangEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles
              .languageEvaluator.totalCompleted) ||
          0;
        totalCountLangEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles
              .languageEvaluator.totalCount) ||
          0;
        let percentCompleteLangEvaluator =
          (totalCompletedLangEvaluator / totalCountLangEvaluator) * 100;
        if (percentCompleteLangEvaluator) {
          return this.getStatus(percentCompleteLangEvaluator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.moderator:
        let totalCompletedModerator;
        let totalCountModerator;
        totalCompletedModerator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.moderator
              .totalCompleted) ||
          0;
        totalCountModerator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.moderator
              .totalCount) ||
          0;
        let percentCompleteModerator =
          (totalCompletedModerator / totalCountModerator) * 100;
        if (percentCompleteModerator) {
          return this.getStatus(percentCompleteModerator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.publisher:
        let totalCompletedPublisher;
        let totalCountPublisher;
        totalCompletedPublisher =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.publisher
              .totalCompleted) ||
          0;
        totalCountPublisher =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.publisher
              .totalCount) ||
          0;
        let percentCompletePublisher =
          (totalCompletedPublisher / totalCountPublisher) * 100;
        if (percentCompletePublisher) {
          return this.getStatus(percentCompletePublisher);
        } else {
          return StepStatus.PENDING;
        }
      default:
    }
  }

  getSubStepStatusTest(role: RoleTypes) {
    console.log('Content Request', this.props.contentRequest)
    let overallCompleted;
    let overallCount;
    overallCompleted = _.get(this.props.contentRequest, 'progress.details.test.totalCompleted', 0);
    overallCount = _.get(this.props.contentRequest, 'progress.details.test.totalCount', 0);
    const overallPercent = (overallCompleted / overallCount) * 100;

    switch (role) {
      case RoleTypes.creator:
        let totalCompletedCreator;
        let totalCountCreator;
        totalCompletedCreator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.creator
              .totalCompleted) ||
          0;
        totalCountCreator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.creator
              .totalCount) ||
          0;
        let percentCompleteCreator =
          (totalCompletedCreator / totalCountCreator) * 100;
        if (percentCompleteCreator) {
          return this.getStatus(percentCompleteCreator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.evaluator:
        let totalCompletedEvaluator;
        let totalCountEvaluator;
        totalCompletedEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.evaluator
              .totalCompleted) ||
          0;
        totalCountEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.evaluator
              .totalCount) ||
          0;
        let percentCompleteEvaluator =
          (totalCompletedEvaluator / totalCountEvaluator) * 100;
        if (percentCompleteEvaluator) {
          return this.getStatus(percentCompleteEvaluator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.langEvaluator:
        let totalCompletedLangEvaluator;
        let totalCountLangEvaluator;
        totalCompletedLangEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles
              .languageEvaluator.totalCompleted) ||
          0;
        totalCountLangEvaluator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles
              .languageEvaluator.totalCount) ||
          0;
        let percentCompleteLangEvaluator =
          (totalCompletedLangEvaluator / totalCountLangEvaluator) * 100;
        if (percentCompleteLangEvaluator) {
          return this.getStatus(percentCompleteLangEvaluator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.moderator:
        let totalCompletedModerator;
        let totalCountModerator;
        totalCompletedModerator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.moderator
              .totalCompleted) ||
          0;
        totalCountModerator =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.moderator
              .totalCount) ||
          0;
        let percentCompleteModerator =
          (totalCompletedModerator / totalCountModerator) * 100;
        if (percentCompleteModerator) {
          return this.getStatus(percentCompleteModerator);
        } else {
          return StepStatus.PENDING;
        }
      case RoleTypes.publisher:
        let totalCompletedPublisher;
        let totalCountPublisher;
        totalCompletedPublisher =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.publisher
              .totalCompleted) ||
          0;
        totalCountPublisher =
          (this.props.contentRequest &&
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.publisher
              .totalCount) ||
          0;
        let percentCompletePublisher =
          (totalCompletedPublisher / totalCountPublisher) * 100;
        if (percentCompletePublisher) {
          return this.getStatus(percentCompletePublisher);
        } else {
          return StepStatus.PENDING;
        }
      default:
    }
  }

  getProgressPercent(totalCompleted: any, totalCount: any) {
    if (totalCompleted === 0 || totalCompleted === undefined) {
      return 0;
    }
    return (totalCompleted / totalCount) * 100;
  }

  getQuestionContentOwnerNames(role: RoleTypes) {
    if (this.props.contentRequest) {
      switch (role) {
        case RoleTypes.creator:
          const creatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.creator.authors.map(
              (author: any) => author.name
            );
          return creatorNames && creatorNames.join(",");

        case RoleTypes.evaluator:
          const evaluatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.evaluator.authors.map(
              (author: any) => author.name
            );

          return evaluatorNames && evaluatorNames.join(",");

        case RoleTypes.langEvaluator:
          const langEvaluatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.languageEvaluator.authors.map(
              (author: any) => author.name
            );

          return langEvaluatorNames && langEvaluatorNames.join(",");

        case RoleTypes.moderator:
          const moderatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.moderator.authors.map(
              (author: any) => author.name
            );

          return moderatorNames && moderatorNames.join(",");

        case RoleTypes.publisher:
          const publisherNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.publisher.authors.map(
              (author: any) => author.name
            );

          return publisherNames && publisherNames.join(",");
        default:
      }
    }
  }

  getTestContentOwnerNames(role: RoleTypes) {
    if (this.props.contentRequest) {
      switch (role) {
        case RoleTypes.creator:
          const creatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.creator.authors.map(
              (author: any) => author.name
            );
          return creatorNames && creatorNames.join(",");

        case RoleTypes.evaluator:
          const evaluatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.evaluator.authors.map(
              (author: any) => author.name
            );

          return evaluatorNames && evaluatorNames.join(",");

        case RoleTypes.langEvaluator:
          const langEvaluatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.languageEvaluator.authors.map(
              (author: any) => author.name
            );

          return langEvaluatorNames && langEvaluatorNames.join(",");

        case RoleTypes.moderator:
          const moderatorNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.moderator.authors.map(
              (author: any) => author.name
            );

          return moderatorNames && moderatorNames.join(",");

        case RoleTypes.publisher:
          const publisherNames =
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.publisher.authors.map(
              (author: any) => author.name
            );

          return publisherNames && publisherNames.join(",");
        default:
      }
    }
  }

  getContentUserNames(owners: any) {
    const { classes } = this.props;
    let ownerNames = "";
    owners.forEach((owner: any) => {
      owner.client.users.forEach((user: any) => {
        ownerNames += user.name + ",";
      });
    });

    if (ownerNames.split(",").length > 2) {
      return "Multiple Users";
    } else {
      return ownerNames;
    }
  }

  getContentOwnersDeadline(role: RoleTypes, requestType: Owners["type"], relevantOwners: Owners[]) {
    let authorRole: string = role;
    if(role === RoleTypes.langEvaluator) {
      authorRole = "languageEvaluator"
    }
    const { contentRequest } = this.props;
    
    const owner = relevantOwners.find(({ type }) => type === requestType);

    const deadline = _.get(owner, `roles[${authorRole}].endDate`, '');
    if(deadline) {
      return dateService.dateFromString(deadline);
    }
    return 'NA'
  }

  getContentOwnerQuestionProgressCards(relevantOwners: Owners[]) {
    const { classes } = this.props;
    let contentOwnerProgressCards = [];
    if (this.props.contentRequest) {

      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusContent(RoleTypes.creator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Created
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Creator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getQuestionContentOwnerNames(RoleTypes.creator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.creator, 'subject', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>Status: </span>
              <span className={classes.contentSubTitle}>
                {this.getSubStepStatusContent(RoleTypes.creator) || "N/A"}
              </span>
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles.creator
                .totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles.creator
                .totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.creator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.creator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusContent(RoleTypes.evaluator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Evaluated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Evaluator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getQuestionContentOwnerNames(RoleTypes.evaluator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.evaluator, 'subject', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              <span className={classes.contentSubTitle}>
                {this.getSubStepStatusContent(RoleTypes.evaluator) || "N/A"}
              </span>
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .evaluator.totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .evaluator.totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.evaluator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.evaluator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusContent(RoleTypes.langEvaluator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Language Evaluated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>
                  Lang. Evaluator(s) :{" "}
                </span>
                <span className={classes.contentSubTitle}>
                  {this.getQuestionContentOwnerNames(
                    RoleTypes.langEvaluator
                  ) || "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.langEvaluator, 'subject', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              <span className={classes.contentSubTitle}>
                {this.getSubStepStatusContent(RoleTypes.langEvaluator) || "N/A"}
              </span>
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .languageEvaluator.totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .languageEvaluator.totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles
              .languageEvaluator.totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles
              .languageEvaluator.totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusContent(RoleTypes.moderator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Moderated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Moderator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getQuestionContentOwnerNames(RoleTypes.moderator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.moderator, 'subject', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              {this.getSubStepStatusContent(RoleTypes.moderator) || "N/A"}
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .moderator.totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .moderator.totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.moderator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.moderator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusContent(RoleTypes.publisher)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Published
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Publisher(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getQuestionContentOwnerNames(RoleTypes.publisher) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.publisher, 'subject', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              {this.getSubStepStatusContent(RoleTypes.publisher) || "N/A"}
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .publisher.totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.question.roles
                .publisher.totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.publisher
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.question.roles.publisher
              .totalCount
          }
        />
      );
      return contentOwnerProgressCards;
    }
  }

  getSyllabusRenderValue = (questionIndex: number, subjectIndex: number) => {
    const subjects = _.get(
      this.props.contentRequest.requestInfo.details,
      `subjects[${subjectIndex}].questions[${questionIndex}].syllabus.subjects`,
      []
    );
    const data = subjects.reduce((acc: string[], subject: any) => {
      const { checked: subjectCheck, subSubjects, subjectId } = subject;
      if (!subjectId) {
        return acc;
      }
      if (subjectCheck || subjectId.checked) {
        acc.push(subjectId.name);
        return acc;
      }

      for (let subSubject of subSubjects) {
        const { checked: subSubjectCheck, chapters, subSubjectId } = subSubject;
        if (!subSubjectId) {
          continue;
        }
        if (subSubjectId.checked || subSubjectCheck) {
          acc.push(subSubjectId.name);
          continue;
        }
        for (let chapter of chapters) {
          const { checked: chapterCheck, concepts, chapterId } = chapter;
          if (!chapterId) {
            return acc;
          }

          if (chapterId.checked || chapterCheck) {
            acc.push(chapterId.name);
            continue;
          }
          for (let concept of concepts) {
            const { checked: conceptCheck, conceptId } = concept;

            if (!conceptId) {
              return acc;
            }
            if (conceptId.checked || conceptCheck) {
              acc.push(conceptId.name);
              continue;
            }
          }
        }
      }

      return acc;
    }, []);
    return data.join(", ");
  };

  getContentOwnerTestProgressCards(relevantOwners: Owners[]) {
    const { classes } = this.props;
    let contentOwnerProgressCards = [];
    if (this.props.contentRequest) {
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusTest(RoleTypes.creator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Created
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Creator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getTestContentOwnerNames(RoleTypes.creator) ||
                    "N/A"}
                </span>
                  
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.creator, 'test-compiler', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              {this.getSubStepStatusTest(RoleTypes.creator) || "N/A"}
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.creator
                .totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.creator
                .totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.creator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.creator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusTest(RoleTypes.evaluator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Evaluated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Evaluator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getTestContentOwnerNames(RoleTypes.evaluator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.evaluator, 'test-compiler', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              {this.getSubStepStatusTest(RoleTypes.evaluator) || "N/A"}
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.evaluator
                .totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.evaluator
                .totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.evaluator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.evaluator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusTest(RoleTypes.langEvaluator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Language Evaluated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>
                  Lang. Evaluator(s) :{" "}
                </span>
                <span className={classes.contentSubTitle}>
                  {this.getTestContentOwnerNames(RoleTypes.langEvaluator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline: </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.langEvaluator, 'test-compiler', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}> Status: </span>
              <span className={classes.contentSubTitle}>
                {this.getSubStepStatusTest(RoleTypes.langEvaluator) || "N/A"}
              </span>
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles
                .languageEvaluator.totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles
                .languageEvaluator.totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles
              .languageEvaluator.totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles
              .languageEvaluator.totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusTest(RoleTypes.moderator)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Moderated
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Moderator(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getTestContentOwnerNames(RoleTypes.moderator) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.moderator, 'test-compiler', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}>,Status: </span>
              <span className={classes.contentSubTitle}>
                {this.getSubStepStatusTest(RoleTypes.moderator) || "N/A"}
              </span>
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.moderator
                .totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.moderator
                .totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.moderator
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.moderator
              .totalCount
          }
        />
      );
      contentOwnerProgressCards.push(
        <MyPATExpansionStepSubCard
          status={this.getSubStepStatusTest(RoleTypes.publisher)}
          title={
            <>
              <Typography className={classes.summaryContentTitle}>
                Published
              </Typography>
            </>
          }
          secondarySummary={
            <Grid container justify="flex-start" alignItems="center" spacing={16}>
              <Grid item>
                <span className={classes.contentTitle}>Publisher(s) : </span>
                <span className={classes.contentSubTitle}>
                  {this.getTestContentOwnerNames(RoleTypes.publisher) ||
                    "N/A"}
                </span>
              </Grid>
              <Grid item>
                <span className={classes.contentTitle}>Deadline : </span>
                <span className={classes.contentSubTitle}>
                  {this.getContentOwnersDeadline(RoleTypes.publisher, 'test-compiler', relevantOwners) ||
                    "N/A"}
                </span>
              </Grid>
            </Grid>
          }
          taskStatus={
            <>
              <span className={classes.contentTitle}> Status: </span>
              {this.getSubStepStatusTest(RoleTypes.publisher) || "N/A"}
            </>
          }
          percent={this.getProgressPercent(
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.publisher
                .totalCompleted,
            this.props.contentRequest.progress &&
              this.props.contentRequest.progress.details.test.roles.publisher
                .totalCount
          )}
          count={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.publisher
              .totalCompleted
          }
          totalCount={
            this.props.contentRequest.progress &&
            this.props.contentRequest.progress.details.test.roles.publisher
              .totalCount
          }
        />
      );
      return contentOwnerProgressCards;
    }
  }
  handleShowSyllabusPopup = (rowIndex: number) => () => {
    this.setState((prevState) => {
      const newDraftSyllabus = JSON.parse(
        JSON.stringify(prevState.rows[rowIndex].syllabus)
      );

      return {
        ...prevState,
        draftSyllabus: newDraftSyllabus,
        showSyllabusPopup: true,
        activeRowIndexForPopup: rowIndex,
      };
    });
  };

  renderActiveSubjectTable = (subject: any, subjectIndex: number) => {
    const { classes } = this.props;
    const { activeSubjectTab } = this.state;
    let questionRows: any = [];
    subject.questions.map((question: any, index: any) => {
      const syllabusRenderValue = this.getSyllabusRenderValue(
        index,
        subjectIndex
      );
      questionRows.push(
        <TableRow>
          <TableCell>{index + 1}</TableCell>
          <TableCell>{question.count}</TableCell>
          <TableCell>{question.type}</TableCell>
          <TableCell
            style={
              syllabusRenderValue.length === 0
                ? { height: "36px" }
                : { height: "95px" }
            }
          >
            <PerfectScrollbar>
              <div
                style={
                  syllabusRenderValue.length === 0
                    ? { height: "42px" }
                    : { marginTop: "0px" }
                }
              >
                {syllabusRenderValue}
              </div>
            </PerfectScrollbar>
          </TableCell>
          <TableCell>
            <div className={classes.addtionalDes1}>
            <PerfectScrollbar>
              {question &&
                question.authors &&
                question.authors.map((typeAuthor: any) => {
                  return (
                    <div style={{ maxHeight: "100px" }}>
                      <div>
                        <span className={classes.fontBold}>
                          {_.capitalize(
                            typeAuthor.type === "languageEvaluator"
                              ? "L.Evalutor"
                              : typeAuthor.type
                          )}
                          :{" "}
                        </span>
                        <span className={classes.grayFont}>
                          {`${typeAuthor.name} | ${typeAuthor.client.name}`}{" "}
                        </span>
                      </div>
                    </div>
                  );
                })}
            </PerfectScrollbar>
            </div>
          </TableCell>
          <TableCell>
            {/* {extractContent()} */}
            <div className={classes.addtionalDes1} dangerouslySetInnerHTML={{ __html: question.description }}>

            </div>
          </TableCell>
        </TableRow>
      );
    });
    return questionRows;
  };
  handleSubjectTab = (subjectName: string) => {
    this.setState({ activeSubjectTab: subjectName });
  };
  getTabsForSubjects() {
    const { classes } = this.props;
    const { activeSubjectTab } = this.state;
    let subjectTabs = [];
    if (
      this.props.contentRequest &&
      this.props.contentRequest.requestInfo &&
      this.props.contentRequest.requestInfo.details.subjects
    ) {
      let subjectTabs: any = [];
      this.props.contentRequest.requestInfo.details.subjects.forEach(
        (subject: any, subjectIndex: number) => {
          subjectTabs.push(
            <MyPATTab
              eventKey={subject.name}
              isCustomCSS={true}
              fontWeight={600}
              customColor="#1d7dea"
              borderBottom="solid 4px #1d7dea"
            >
              <Grid
                style={{ minHeight: 350, maxHeight: 600, overflowY: "auto" }}
              >
                <Grid
                  container
                  justify="flex-start"
                  style={{
                    position: "absolute",
                    top: "45px",
                    left: "0px",
                    marginTop: "30px",
                    right: "0",
                    height: "250px",
                    overflow: "auto",
                    width: "99%",
                  }}
                >
                  <Grid item style={{ width: "99%" }}>
                  <Grid container alignItems="center" justify="flex-start">
                    <Grid item>
                      <Typography className={classes.rightText}>
                        Assigned to
                      <span>: {_.get(subject, 'questions[0].authors[0].client.name', "").substring(_.get(subject, 'questions[0].authors[0].name', "").indexOf('|') + 1).trim()}</span>
                      </Typography>
                    </Grid>
                  </Grid>
                    <Table
                      className={[
                        classes.contentOwnerDeadlineTable,
                        classes.vTOp,
                      ].join(" ")}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell classes={{ root: classes.smallWidth }}>
                            S. No.
                          </TableCell>
                          <TableCell className={classes.countColunmwidth}>
                            Count
                          </TableCell>
                          <TableCell classes={{ root: classes.paddingR0 }}>
                            Question Type
                          </TableCell>
                          <TableCell classes={{ root: classes.largeWidth }}>
                            Syllabus for the Content &nbsp;
                            <CustomInfoIcon
                              infoDialogContentType="Add Syllabus for the content"
                              isCenterArrow={true}
                              isRightArrow={false}
                              isInfoIcon={true}
                              knowMoreAbout={false}
                              dialogTitle="Add Syllabus for the content"
                              imageURL="/assets/svg/contentRequest/syllabusIcon.svg"
                              dialogPara="In this column you have to tag relevant syllabus of the content as per the requirement."
                              details="Click to know more"
                              toolTipDirection="top"
                            />
                          </TableCell>
                          <TableCell classes={{ root: classes.largeWidth }}>
                            Content Authors
                          </TableCell>
                          <TableCell classes={{ root: classes.largeWidth }}>
                            Additional Description
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ height: "200px", overflow: "auto" }}>
                        {this.renderActiveSubjectTable(subject, subjectIndex)}
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </Grid>
            </MyPATTab>
          );
        }
      );

      return (
        <>
          <Grid container>
            <MyPATTabs
              activeTab={activeSubjectTab}
              handleActiveTabChange={this.handleSubjectTab.bind(this)}
            >
              {subjectTabs}
            </MyPATTabs>
          </Grid>
        </>
      );
    }
  }

  getYourTasks() {
    let tasks: any = [];
    if (this.props.contentRequest) {
      this.props.contentRequest.requestInfo.details.subjects.forEach(
        (subject: any) => {
          const task = (
            <YourTask
              // testDetails={mockTestDetails.testDetails}
              // totalCount={totalCount}
              questionData={
                this.props.contentRequest &&
                this.props.contentRequest.requestInfo &&
                this.props.contentRequest.requestInfo.details &&
                this.props.contentRequest.requestInfo.details.subjects[0] &&
                this.props.contentRequest.requestInfo.details.subjects[0]
                  .questions
              }
              // contentRequestId={_id} requestId={requestId}
              // history={history}
              // handleChooseFromLibrary={this.handleChooseFromLibrary}
              // type = {type}
            />
          );
          tasks.push(task);
        }
      );
    }
    return tasks;
  }

  transformPriorityText(priority: any) {
    switch (priority) {
      case "IMPORTANT_AND_URGENT":
        return PriorityTitle.importantAndUrgent;
        break;
      case "NOT_IMPORTANT_BUT_URGENT":
        return PriorityTitle.notImportantButUrgent;
        break;
      case "IMPORTANT_BUT_NOT_URGENT":
        return PriorityTitle.importantButNotUrgent;
        break;
      case "NOT_IMPORTANT_AND_NOT_URGENT":
        return PriorityTitle.notImportantAndNotUrgent;
        break;
      default:
    }
  }

  getSubjectsName = (requestData: any) => {
    const names: string[] = [];
    const subjects = _.get(requestData, "requestInfo.details.subjects", []);
    subjects.forEach((subject: any) => {
      names.push(_.capitalize(subject.name));
    });

    return names.length > 0 ? names : ["N/A"];
  };
  getTopNav() {
    const requestOwnerData = _.get(
      this.props.contentRequest,
      "requestInfo.owners",
      []
    ).map((owners: any) => owners.client.name);
    const goalOwnerData = _.get(
      this.props.contentRequest,
      "requestInfo.details.courseTypes",
      []
    ).map((coursetype: any) => coursetype.name);
    const subjectOwnerName = _.get(
      this.props.contentRequest,
      "requestInfo.details.subjects",
      []
    ).map((subjects: any) => subjects.name);
    if (this.props.contentRequest && this.props.contentRequest.requestInfo) {
      const priority = _.get(
        this.props,
        "contentRequest.requestInfo.priority",
        ""
      );
      const priorityDisplayValue = convertRequestPriorityToDislayValue(
        priority
      );

      if (this.state.isUserMultiCenterHead) {
        let topNavValue = {
          Priority: priorityDisplayValue,
          Deadline:
            !_.isEmpty(this.props.contentRequest) &&
            _.get(this.props.contentRequest.requestInfo, "endDate", "") !==
              null &&
            dateService.dateFromString(
              _.get(this.props.contentRequest.requestInfo, "endDate", "")
            ),
          "Request Owners": (
            <MyPATTruncateText
              data={requestOwnerData}
              truncateLength={19}
              displayCount={2}
            />
          ),
          Status:
            this.props.contentRequest.publishedOn !== null
              ? `Published, ${dateService.timeSince(
                  this.props.contentRequest.publishedOn
                )}`
              : "",
        };
        return topNavValue;
      }

      if (this.props.contentRequest && this.props.contentRequest.requestInfo) {
        if (this.state.isUserCenterHead) {
          let topNavValue = {
            Priority: priorityDisplayValue,
            Deadline:
              !_.isEmpty(this.props.contentRequest) &&
              _.get(this.props.contentRequest.requestInfo, "endDate", "") !==
                null &&
              dateService.dateFromString(
                _.get(this.props.contentRequest.requestInfo, "endDate", "")
              ),
            //"Goal": !_.isEmpty(this.props.contentRequest) && _.get(this.props.contentRequest, 'requestInfo.details.courseTypes[0].name', ''),
            Goal: (
              <MyPATTruncateText
                data={goalOwnerData}
                truncateLength={15}
                displayCount={1}
              />
            ),
            "Content Request for": (
              <MyPATTruncateText
                data={this.getSubjectsName(this.props.contentRequest)}
                truncateLength={11}
                displayCount={2}
              />
            ),
            "Assigned by":
              !_.isEmpty(this.props.contentRequest) &&
              getRequestCreatorName(this.props.contentRequest),
          };
          return topNavValue;
        }
      }

      if (this.state.isUserContentAuthor) {
        let topNavValue = {
          Priority: priorityDisplayValue,
          Deadline:
            !_.isEmpty(this.props.contentRequest) &&
            _.get(this.props.contentRequest.requestInfo, "endDate", "") !==
              null &&
            dateService.dateFromString(
              _.get(this.props.contentRequest.requestInfo, "endDate", "")
            ),
          // "Goal": !_.isEmpty(this.props.contentRequest) && _.get(this.props.contentRequest, 'requestInfo.details.courseTypes[0].name', ''),
          Goal: (
            <MyPATTruncateText
              data={goalOwnerData}
              truncateLength={15}
              displayCount={1}
            />
          ),
          Subject: !_.isEmpty(this.props.contentRequest) && (
            <MyPATTruncateText
              data={subjectOwnerName}
              truncateLength={11}
              displayCount={1}
            />
          ),
          "Assigned by":
            !_.isEmpty(this.props.contentRequest) &&
            _.get(
              this.props.contentRequest.requestInfo,
              "details.subjects[0].assignor.name",
              ""
            ),
        };
        return topNavValue;
      }
    }
  }

  onEdit = () => {
    const userData = ACLService.getUserDetailsFromStorage();
    const requestType = this.props.contentRequest.requestInfo.type;
    if (this.props.contentRequest && this.props.contentRequest.aclMetaData) {
      const requestCreatedBy = this.props.contentRequest.aclMetaData.createdBy
        .email;
      const currentUserEmail = userData.authenticatedUser.email;
      if (currentUserEmail === requestCreatedBy) {
        window.open(
          `/contentRequest/edit/${requestType}/${
            this.props.match.params.requestId
          }`
        );
        this.setState({
          isRequestCreatedByMe: true,
        });
      } else {
        if (this.state.isUserCenterHead) {
          window.open(
            `/contentRequest/${this.props.contentRequest.requestInfo.type}/${
              this.props.match.params.requestId
            }/edit`
          );
        }
        this.setState({
          isRequestCreatedByMe: false,
        });
      }
    }
  };

  showSave = () => {
    const userData = ACLService.getUserDetailsFromStorage();
    const requestCreatedBy = _.get(
      this.props.contentRequest,
      "aclMetaData.createdBy.email",
      ""
    );
    if (this.props.contentRequest && this.props.contentRequest.aclMetaData) {
      const requestCreatedBy = this.props.contentRequest.aclMetaData.createdBy
        .email;
      const currentUserEmail = userData.authenticatedUser.aclMetaData.createdBy;
      if (currentUserEmail === requestCreatedBy) {
        this.setState({
          isRequestCreatedByMe: true,
        });
        return true;
      } else {
        this.setState({
          isRequestCreatedByMe: false,
        });
        return false;
      }
    }
  };
  canUserEdit = () => {
    const userData = ACLService.getUserDetailsFromStorage();
    if (this.props.contentRequest && this.props.contentRequest.aclMetaData) {
      const requestCreatedBy = this.props.contentRequest.aclMetaData.createdBy
        .email;
      const currentUserEmail = userData.authenticatedUser.aclMetaData.createdBy;
      if (currentUserEmail === requestCreatedBy) {
        return false;
      } else {
        return true;
      }
    }
  };

  getStatusColor = (StepStatus: any) => {
    const { classes } = this.props;
    if (StepStatus !== undefined) {
      switch (StepStatus) {
        case "Pending":
          return classes.red;
          break;
        case "In Progress":
          return classes.darkYellow;
          break;
        case "Done":
          return classes.green;
          break;
        default:
      }
    }
  };

  renderExpansionHeading = () => {
    const { classes } = this.props;

    return (
      <Grid container justify="flex-end" spacing={16} alignItems="center">
        <Grid item>
          <Grid className={classes.padding30}>
            {
              <>
                <span className={classes.ExpSubTitle}>Total Questions : </span>
                <span className={classes.ExpSubTitle}>
                  {this.getQuestionCount() || "N/A"}
                </span>
              </>
            }
          </Grid>
        </Grid>
        <Grid item>
          <Grid className={classes.padding30}>
            {
              <>
                <span className={classes.ExpTitle}>Status: </span>
                <span
                  className={[
                    classes.ExpSubTitle,
                    this.getStatusColor(
                      this.getContentCreatedQuestionsStatus()
                    ),
                  ].join(" ")}
                >
                  {this.getContentCreatedQuestionsStatus() ===
                  StepStatus.PENDING
                    ? "Not Yet Started"
                    : this.getContentCreatedQuestionsStatus()}
                </span>
              </>
            }
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderStatusForClient = (owner: any) => {
    const subjects = _.get(owner, "subjects", []);
    for (let subject of subjects) {
      const { progress } = subject;
      if (
        !progress ||
        progress.totalCount !== progress.totalCompleted ||
        progress.totalCompleted === 0
      ) {
        return false;
      }
    }
    return true;
  };

  pendingToNotYetStarted() {
    return "Not Yet Started";
  }

  renderContentCreated = (relevantOwners: Owners[]) => {
    const { classes } = this.props;
    const owners = _.get(this.props, "contentRequest.requestInfo.owners", []);

    if (isLoggedInUserMultiCenterHead() && !checkIfRequestForMyOrg(owners)) {
      return (
        <Grid container>
          {owners.map((owner: any, index: number) => {
            const clientName = _.get(owner, "client.name", "");
            const subjects: any[] = _.get(owner, "subjects", []);
            const type = _.get(owner, "type", "subject");
            if (type === "test-compiler") {
              return null;
            }
            return (
              <MyPATExpansionStepSubCard
                status={
                  this.renderStatusForClient(owner)
                    ? StepStatus.DONE
                    : StepStatus.PENDING
                }
                title={
                  <>
                    <Typography className={classes.summaryContentTitle}>
                      {clientName}
                    </Typography>
                  </>
                }
                genericSecondarySummary={
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                      {subjects.map((subject, index: number) => {
                        return (
                          <div key={index}>
                            <Typography variant="subheading">
                              <strong>Subject: </strong>
                              {subject.name}
                            </Typography>
                          </div>
                        );
                      })}
                    </Grid>
                    <Grid item>
                      {subjects.map((subject, index: number) => {
                        const totalCount = _.get(
                          subject,
                          "progress.totalCount",
                          1
                        );
                        const totalCompleted = _.get(
                          subject,
                          "progress.totalCompleted",
                          0
                        );

                        return (
                          <ProgressBar
                            percentage={this.getProgressPercent(
                              totalCompleted,
                              totalCount
                            )}
                            totalCount={totalCount}
                            count={totalCompleted}
                            key={index}
                          />
                        );
                      })}
                    </Grid>
                  </Grid>
                }
              />
            );
          })}
        </Grid>
      );
    }
    return <Grid container>{this.getContentOwnerQuestionProgressCards(relevantOwners)}</Grid>;
  };

  renderTestCreated = (relevantOwners: Owners[]) => {
    const { classes } = this.props;
    const owners = _.get(this.props, "contentRequest.requestInfo.owners", []);

    if (isLoggedInUserMultiCenterHead() && !checkIfRequestForMyOrg(owners)) {
      const testCompilerOwner = owners.find(
        ({ type }: any) => type === "test-compiler"
      );
      if (testCompilerOwner) {
        const clientName = _.get(testCompilerOwner, "client.name", "");
        const totalCount = _.get(testCompilerOwner, "progress.totalCount", 0);
        const totalCompleted = _.get(
          testCompilerOwner,
          "progress.totalCompleted",
          0
        );
        return (
          <MyPATExpansionStepSubCard
            status={
              this.getContentCreatedTestStatus() === StepStatus.PENDING
                ? StepStatus.PENDING
                : this.getContentCreatedTestStatus() === StepStatus.INPROGRESS ? StepStatus.INPROGRESS: StepStatus.DONE
            }
            title={
              <>
                <Typography className={classes.summaryContentTitle}>
                  {clientName}
                </Typography>
              </>
            }
            genericSecondarySummary={
              <Grid container justify="flex-end" alignItems="center">
                <Grid item>
                  <ProgressBar
                    percentage={this.getProgressPercent(
                      totalCompleted,
                      totalCount
                    )}
                    count={totalCompleted}
                    totalCount={totalCount}
                  />
                </Grid>
              </Grid>
            }
          />
        );
      }
    }

    return (
      <Grid container>
        {/* TODO */}
        {this.getContentOwnerTestProgressCards(relevantOwners)}
      </Grid>
    );
  };

  getRelevantOwners = () => {
    // This is used for centre head

    const clientId = _.get(this.props.authUser, 'clientId._id', '');

    if(this.isMultiCenterHead) {
      return _.get(this.props.contentRequest, "requestInfo.owners", []);
    }

    return _.get(this.props.contentRequest, "requestInfo.owners", []).filter((owner: Owners) => {
      return owner.client.id === clientId
    })
  }

  getCreatedStatus = () => {

  }

  getPublishedStatus = () => {
    let owners = this.getRelevantOwners();

    let allInDraft = true;
    let anyInPublishedOrDraft = false;
    let allInPublished = true;
    for (let owner of owners) {
      if (owner.status !== "draft") {
        allInDraft = false;
      }
    }
    for (let owner of owners) {
      if (owner.status !== "published") {
        allInPublished = false;
      }
    }
    for (let owner of owners) {
      if (owner.status === "published" || owner.status === "draft") {
        anyInPublishedOrDraft = true;
      }
    }

    if (allInPublished) {
      console.log('All In Published')
      return StepStatus.DONE;
    }
    if (allInDraft) {
      console.log('All In Draft')
      return StepStatus.PENDING;
    }
    if (!allInPublished && !allInDraft && anyInPublishedOrDraft) {
      console.log('Not All In Published')
      return StepStatus.INPROGRESS;
    }
  };

  getTotalQuestionsCountForMultiCenterHead() {
    const owners = _.get(this.props.contentRequest, "requestInfo.owners", []);
    let totalQuestions = 0;
    for (let owner of owners) {
      owner.subjects.forEach((subject: any) => {
        totalQuestions += subject.progress.totalCount;
      });
    }
    return totalQuestions;
  }
  getTotalOwner = () => {
    const owners = _.get(
      this.props.contentRequest,
      "requestInfo.details.subjects",
      []
    );
    let totalContentAuthours = 0;
    let higherContentAuthors = 0;
    owners.map((subjects: any) => {
      subjects.questions.map((question: any) => {
        higherContentAuthors = question.authors && question.authors.length;
        if (higherContentAuthors > totalContentAuthours) {
          totalContentAuthours = higherContentAuthors;
        }
      });
    });
    return totalContentAuthours;
  };
  getQuestionCount = () => {
    const forQuestionCount = _.get(
      this.props.contentRequest,
      "requestInfo.details.subjects",
      []
    );
    let totalQuestions = 0;
    forQuestionCount.map((subjectQuestion: any) => {
      subjectQuestion.questions.map((questionCount: any) => {
        totalQuestions += questionCount.count;
      });
    });
    return totalQuestions;
  };

  getAssignedToData = () => {
    const relevantOwners: Owners[] = this.getRelevantOwners();
    const clientId = _.get(this.props.authUser, 'clientId._id', '');
    const assignedToData = relevantOwners.map((owners: any) => owners.client.name);
    if(relevantOwners.length === 1 && relevantOwners[0].client.id === clientId) {
      // If the client is same as current user then 
      return ["You"]
    }
    return assignedToData;
  }

  showTestCreatedSection = () => {
    const { contentRequest } = this.props
    const type = _.get(contentRequest, 'requestInfo.type', '');

    if(type !== 'test') {
      return false;
    }
    if(this.isMultiCenterHead) {
      return true;
    }
    // If not multi center head then check if the test-compiler's client is same as auth user
    const relevantOwners: Owners[] = this.getRelevantOwners();
    
    return !!relevantOwners.find(owner => owner.type === 'test-compiler');
  }

  showContentCreatedSection = () => {
    const { contentRequest } = this.props
    const type = _.get(contentRequest, 'requestInfo.type', '');

    if(this.isMultiCenterHead) {
      return true;
    }
    // If not multi center head then check if any subject owner is same as auth user
    const relevantOwners: Owners[] = this.getRelevantOwners();
    return !!relevantOwners.find(owner => owner.type === 'subject');

  }


  render() {
    const { classes, contentRequest } = this.props;
    const { statusCreated, statusPending, requestData } = this.state;
    const title = _.get(contentRequest, "title", "");
    const requestId = _.get(contentRequest, "requestId", "");
    const totalOwners = this.getTotalOwner();
    
    const totalQuestion = this.getQuestionCount();

    const showTestCreatedSection = this.showTestCreatedSection();

    const isTestCompilationDetails =
      _.get(this.props.contentRequest, "requestInfo.type", "") === "test" && showTestCreatedSection
        ? true
        : false;

    const relevantOwners = this.getRelevantOwners(); // Used for centre head

    console.log('::::;;Content Request::::::::::', contentRequest)
    return (
      <>
      <DialogLarge
        headerTitle={`${requestId} | ${title}`}
        isFooter={this.state.isUserContentAuthor}
        topNavValue={this.getTopNav()}
        isSaveHidden={!this.showSave()}
        isShowHeader={this.canUserEdit()}
        showTopNavContent={true}
        onEdit={this.onEdit}
      >
        <Grid container className={classes.tabContainer} alignItems="center">
          <Grid item xs>
            <MyPATTabs defaultSelected="CR Progress Timeline">
              {this.state.isUserContentAuthor && (
                <MyPATTab eventKey="My Tasks" isCustomCSS={true}>
                  <Grid
                    container
                    justify="flex-start"
                    className={classes.tabPanel}
                  >
                    {this.getYourTasks()}
                  </Grid>
                </MyPATTab>
              )}
              <MyPATTab eventKey="CR Progress Timeline" isCustomCSS={true}>
                <Grid container justify="flex-start" className={classes.tabPanel}>
                  <Grid item xs={12}>
                    <MyPATStepper>
                      <MyPATStep status={statusCreated}>
                        <Grid container>
                          <Grid item xs={12}>
                            <MyPATStepTitle>REQUEST CREATED</MyPATStepTitle>
                          </Grid>

                          <Grid item xs={12}>
                            <MyPATStepSubHeading>
                              <span>By </span>
                              {this.props.contentRequest &&
                                this.props.contentRequest.aclMetaData &&
                                this.props.contentRequest.aclMetaData.createdBy
                                  .email}
                              {this.props.contentRequest &&
                                this.props.contentRequest.aclMetaData &&
                                this.props.contentRequest.aclMetaData.createdBy
                                  .email && (
                                  <span className={classes.dotsSeperator}>
                                    &#8226;
                                  </span>
                                )}
                              <span>
                                {this.props.contentRequest &&
                                  dateService.timeDate(
                                    this.props.contentRequest.createdAt
                                  )}
                              </span>
                            </MyPATStepSubHeading>
                          </Grid>
                        </Grid>
                      </MyPATStep>
                      <MyPATStep status={this.getPublishedStatus()}>
                        <Grid container>
                          <Grid item xs={12}>
                            <MyPATStepTitle>REQUEST PUBLISHED</MyPATStepTitle>
                          </Grid>

                          <Grid item xs={12}>
                            {/* By You . 3:20 PM, 2nd Nov */}
                            <MyPATStepSubHeading>
                              {
                                <span>
                                  Assigned to:{" "}
                                  {
                                    <MyPATTruncateText
                                      data={this.getAssignedToData()}
                                      truncateLength={19}
                                      displayCount={2}
                                    />
                                  }
                                </span>
                              }
                              {this.props.contentRequest &&
                                this.props.contentRequest.publishedOn !==
                                  null && (
                                  <>
                                    {/* <span className={classes.dotsSeperator}>&#8226;</span><span>By you</span> */}
                                    <span className={classes.dotsSeperator}>
                                      &#8226;
                                    </span>
                                  </>
                                )}
                              {this.props.contentRequest &&
                                this.props.contentRequest.publishedOn !== null &&
                                ` ${dateService.timeDate(
                                  this.props.contentRequest.publishedOn
                                )}`}
                            </MyPATStepSubHeading>
                          </Grid>
                        </Grid>
                      </MyPATStep>
                      {this.showContentCreatedSection() && (
                          <MyPATExpansionStep
                          // status={this.getContentCreatedStatus()}
                          status={this.getContentCreatedQuestionsStatus()}
                          title="CONTENT CREATED"
                          // subHeading='CONTENT'
                          secondarySummaryExpansionHeading={this.renderExpansionHeading()}
                          expanded={false}
                          // descriptionHeading={
                          // <>
                          //   <span>
                          //   {this.props.contentRequest &&
                          //   this.props.contentRequest.requestInfo &&
                          //   this.props.contentRequest.requestInfo.owners &&
                          //   this.getContentUserNames(this.props.contentRequest.requestInfo.owners)}
                          //   </span><span className={classes.dotsSeperator}>&#8226;</span>
                          //   <span>{this.getContentCreatedTestStatus()}</span>
                          //   </>
                          //   }
                          // description='TESTING'
                          // taskStatus={`Status: ${this.getContentCreatedQuestionsStatus()}`}
                        >
                          {this.renderContentCreated(relevantOwners)}
                        </MyPATExpansionStep>
                      )}
                      {showTestCreatedSection && (
                          <MyPATExpansionStep
                            status={this.getContentCreatedTestStatus()}
                            title="TEST CREATED"
                            secondarySummaryExpansionHeading={
                              <Grid
                                container
                                justify="flex-end"
                                spacing={16}
                                alignItems="center"
                              >
                                <Grid item>
                                  <Grid className={classes.padding30}>
                                    {
                                      <>
                                        <span className={classes.ExpSubTitle}>
                                          Total Tests :{" "}
                                        </span>
                                        <span className={classes.ExpSubTitle}>
                                          {(this.props.contentRequest &&
                                            this.props.contentRequest
                                              .requestInfo &&
                                            this.props.contentRequest.requestInfo
                                              .totalCount) ||
                                            "N/A"}
                                        </span>
                                      </>
                                    }
                                  </Grid>
                                </Grid>
                                <Grid item>
                                  <Grid className={classes.padding30}>
                                    <span className={classes.ExpTitle}>
                                      Status:{" "}
                                    </span>
                                    <span
                                      className={[
                                        classes.ExpSubTitle,
                                        this.getStatusColor(
                                          this.getContentCreatedTestStatus()
                                        ),
                                      ].join(" ")}
                                    >
                                      {`${
                                        this.getContentCreatedTestStatus() ===
                                        StepStatus.PENDING
                                          ? "Not Yet Started"
                                          : this.getContentCreatedTestStatus()
                                      }`}
                                    </span>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                            expanded={false}
                            descriptionHeading={
                              <>
                                <span>
                                  {this.props.contentRequest &&
                                    this.props.contentRequest.requestInfo &&
                                    this.props.contentRequest.requestInfo
                                      .owners &&
                                    this.getContentUserNames(
                                      this.props.contentRequest.requestInfo.owners
                                    )}{" "}
                                </span>
                                <span className={classes.dotsSeperator}>
                                  &#8226;
                                </span>
                                <span> {this.getContentCreatedTestStatus()}</span>
                              </>
                            }
                            // description='TESTING'
                            // taskStatus={`Status: ${this.getContentCreatedTestStatus()}`}
                          >
                            {this.renderTestCreated(relevantOwners)}
                          </MyPATExpansionStep>
                        )}
                    </MyPATStepper>
                  </Grid>
                </Grid>
              </MyPATTab>
              <MyPATTab eventKey={"Order Notes"} isCustomCSS={true}>
                <Grid className={classes.tabPanel}>
                  <OrderNotes
                    testName={
                      this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.details &&
                      this.props.contentRequest.requestInfo.details.testDetails &&
                      this.props.contentRequest.requestInfo.details.testDetails
                        .name
                    }
                    subjects={
                      this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.details &&
                      this.props.contentRequest.requestInfo.details.subjects
                    }
                    type={
                      this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.details &&
                      this.props.contentRequest.requestInfo.details.testDetails &&
                      this.props.contentRequest.requestInfo.details.testDetails
                        .type
                    }
                    orderNoteBy={getRequestCreatorName(this.props.contentRequest)}
                    note={
                      this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.orderNote
                    }
                    attachments={_.get(
                      this.props,
                      "contentRequest.requestInfo.orderNoteAttachments",
                      []
                    )}
                    requestContentType={_.get(
                      this.props.contentRequest,
                      "requestInfo.type",
                      ""
                    )}
                    requestData={requestData}
                    showGoal={this.state.isUserMultiCenterHead}
                  />
                </Grid>
              </MyPATTab>
              {/* {this.state.isUserCenterHead && */}
              {(this.isCenterHead || checkIfRequestForMyOrg(
                _.get(this.props, "contentRequest.requestInfo.owners", [])
              )) && (
                <MyPATTab
                  eventKey="Content Owners & Deadlines"
                  isCustomCSS={true}
                >
                  <Grid className={classes.tabPanel}>
                    <CreateOwnerDealine
                      isTestCompilationDetails={isTestCompilationDetails}
                      subjectAndQuestionsTabs={this.getTabsForSubjects()}
                      totalOwners={totalOwners}
                      totalQuestions={totalQuestion}
                      creatorEndDate={
                        this.props.contentRequest &&
                        relevantOwners &&
                        relevantOwners[0] &&
                        relevantOwners[0].roles &&
                        relevantOwners[0].roles
                          .creator &&
                        dateService.dateFromString(
                          relevantOwners[0].roles
                            .creator.endDate
                        )
                      }
                      evaluatorEndDate={
                        this.props.contentRequest &&
                        this.props.contentRequest.requestInfo &&
                        relevantOwners &&
                        relevantOwners[0] &&
                        relevantOwners[0].roles &&
                        relevantOwners[0].roles
                          .evaluator &&
                        dateService.dateFromString(
                          relevantOwners[0].roles
                            .evaluator.endDate
                        )
                      }
                      langEvaluatorEndDate={
                        this.props.contentRequest &&
                        this.props.contentRequest.requestInfo &&
                        relevantOwners &&
                        relevantOwners[0] &&
                        relevantOwners[0].roles &&
                        relevantOwners[0].roles
                          .languageEvaluator &&
                        dateService.dateFromString(
                          relevantOwners[0].roles
                            .languageEvaluator.endDate
                        )
                      }
                      moderatorEndDate={
                        this.props.contentRequest &&
                        this.props.contentRequest.requestInfo &&
                        relevantOwners &&
                        relevantOwners[0] &&
                        relevantOwners[0].roles &&
                        relevantOwners[0].roles
                          .moderator &&
                        dateService.dateFromString(
                          relevantOwners[0].roles
                            .moderator.endDate
                        )
                      }
                      publisherEndDate={
                        this.props.contentRequest &&
                        this.props.contentRequest.requestInfo &&
                        relevantOwners &&
                        relevantOwners[0] &&
                        relevantOwners[0].roles &&
                        relevantOwners[0].roles
                          .publisher &&
                        dateService.dateFromString(
                          relevantOwners[0].roles
                            .publisher.endDate
                        )
                      }
                      creator={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.question.roles
                          .creator.authors &&
                        this.props.contentRequest.progress.details.question.roles
                          .creator.authors[0] &&
                        this.props.contentRequest.progress.details.question.roles
                          .creator.authors[0].name
                      }
                      evaluator={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.question.roles
                          .evaluator.authors &&
                        this.props.contentRequest.progress.details.question.roles
                          .evaluator.authors[0] &&
                        this.props.contentRequest.progress.details.question.roles
                          .evaluator.authors[0].name
                      }
                      langEvaluator={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.question.roles
                          .languageEvaluator.authors &&
                        this.props.contentRequest.progress.details.question.roles
                          .languageEvaluator.authors[0] &&
                        this.props.contentRequest.progress.details.question.roles
                          .languageEvaluator.authors[0].name
                      }
                      moderator={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.question.roles
                          .moderator.authors &&
                        this.props.contentRequest.progress.details.question.roles
                          .moderator.authors[0] &&
                        this.props.contentRequest.progress.details.question.roles
                          .moderator.authors[0].name
                      }
                      publisher={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.question.roles
                          .publisher.authors &&
                        this.props.contentRequest.progress.details.question.roles
                          .publisher.authors[0] &&
                        this.props.contentRequest.progress.details.question.roles
                          .publisher.authors[0].name
                      }
                      testType={_.get(
                        this.props.contentRequest,
                        "requestInfo.details.testDetails.type",
                        ""
                      )}
                      additionalDescription={_.get(
                        this.props.contentRequest,
                        "requestInfo.details.testDetails.description",
                        ""
                      )}
                      totalTest={
                        this.props.contentRequest &&
                        this.props.contentRequest.progress &&
                        this.props.contentRequest.progress.details &&
                        this.props.contentRequest.progress.details.test &&
                        this.props.contentRequest.progress.details.test.totalCount
                      }
                      contentRequest={this.props.contentRequest}
                    />
                  </Grid>
                </MyPATTab>
              )}
            </MyPATTabs>
          </Grid>
          <Grid item xs="auto" className={classNames(classes.clickable, classes.historyCTA)} onClick={this.toggleShowContentHistory}>
            <Grid container alignItems="center">
              <Grid item xs="auto">
                <img src="/assets/svg/contentRequest/history-clock.svg" alt="history" />
              </Grid>
              <Grid item xs="auto">
                History
              </Grid>
            </Grid >
          </Grid>
        </Grid>
      </DialogLarge>
      {this.props.contentRequest && (
        <RequestHistoryDrawer key={_.get(this.props.contentRequest, '_id', '')} contentRequest={this.props.contentRequest} open={this.state.showContentHistory} onClose={this.toggleShowContentHistory} />
      )}
      </>
    );
  }
}
const EMPTY_DRAFT_SYLLABUS = {
  secondarySubjects: [],
  subjects: [],
};

const EMPTY_ROW = {
  authors: [],
  syllabus: EMPTY_DRAFT_SYLLABUS,
  count: 1,
  contentRequestItemsId: null,
  passage: [],
  description: "",
  endDate: "",
  startDate: "",
  code: "0",
  type: "SMCQ",
};
const mapStateToProps = (state: any) => ({
  contentRequest:
    state.contentRequestReducer.contentRequestReducer.contentRequest,
  authUser: _.get(state, 'loginData.userData.authenticatedUser'),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getContentRequest
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(userStyles, { index: 1 })(AfterAssingment));
